<script>
    import {onMount} from 'svelte';

    import {userStore} from '@js/stores/userStore';
    import {poiStore} from '@js/stores/poiStore';

    import {MAP_CLASS, MAP_MODULES} from '@js/modules/maps/mapConstants';
    import MapBuilder from '@js/modules/maps/MapBuilder';

    import MapLayers from '@js/components/maps/MapLayers.svelte';

    const {
        mapId,
        mapClass,
        isPlanToStartMode = false,
        onMapLoaded,
        onPoiAdded,
        onPoiEdit,
        onPoiMoved,
        onPoiRemoved
    } = $props();

    let _previousMapLocationValue;

    const _setMapLocation = (bbox, center /*, placeType */) => {
        poiStore.map.goToLocation(bbox, center, {
            showPositionMarker: !isPlanToStartMode,
            startMarker: false
        });
    };

    const _handleMapStyleChange = (mapStyle) => {
        if (!poiStore.map) {
            return;
        }

        poiStore.map.setMapStyle(mapStyle);
    };

    const _loadPlanMap = () => {
        const mapModules = [MAP_MODULES.RIDE_TRACK];
        if (isPlanToStartMode) {
            mapModules.push(MAP_MODULES.COMPUTE_ROAD);
            mapModules.push(MAP_MODULES.DRAW_LINE);
            mapModules.push(MAP_MODULES.GEOLOCATION);
            mapModules.push(MAP_MODULES.HELPER);
        }

        MapBuilder.createMap(
            MAP_CLASS.PLAN,
            mapModules,
            {
                mapId,
                isPlanToStartMode,
                resetBounds: true,
                clusterMode: true,
                minZoom: 13
            }
        )
            .then((map) => {
                poiStore.map = map;

                if (!poiStore.map) {
                    return;
                }

                if (onMapLoaded) {
                    onMapLoaded();
                }

                poiStore.map.onPoiPlanLoaded((pois) => poiStore.planPois = pois);

                poiStore.map.onPoiAddedClicked(onPoiAdded);

                poiStore.map.onPoiEditClicked(onPoiEdit);

                poiStore.map.onPoiMovedClicked(onPoiMoved);

                poiStore.map.onPoiRemovedClicked(onPoiRemoved);
            });
    };

    onMount(() => {
        if (!poiStore.map) {
            _loadPlanMap();
        }

        return () => {
            if (poiStore.map) {
                poiStore.map.destroy();
                poiStore.map = null;
            }
        };
    });

    $effect(() => {
        if ($poiStore.mapLocation && ($poiStore.mapLocation.bbox || $poiStore.mapLocation.center) && _previousMapLocationValue !== $poiStore.mapLocation.value) {
            _previousMapLocationValue = $poiStore.mapLocation.value;

            _setMapLocation($poiStore.mapLocation.bbox, $poiStore.mapLocation.center, $poiStore.mapLocation.placeType);
        }
    });
</script>

<div id={mapId}
     class="my-4">
    <div class="map-area">
        <div id={`${mapId}-map`}
             class={`map-canvas ${mapClass}`}>
            {#if $userStore.featureFlags.map_available_layers?.length}
                <MapLayers mapLayersAvailable={$userStore.featureFlags.map_available_layers}
                           onMapStyleChange={_handleMapStyleChange}/>
            {/if}
        </div>
    </div>
</div>
